import React from 'react';
import { CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { GiMagickTrick, GiNotebook, GiTeacher } from 'react-icons/gi';
import { FaBook, FaMedal, FaUserGraduate } from 'react-icons/fa6';
import { FaPencilAlt, FaPencilRuler } from 'react-icons/fa';
import { SiLibreofficemath } from 'react-icons/si';
import { RiFormula } from 'react-icons/ri';
import { PiExamFill } from 'react-icons/pi';

// Only the parts hasRefinement reads, so filters typed in the search box can be checked too.
export type RefinementItem = Pick<CurrentRefinementsConnectorParamsItem, 'attribute'> & {
  refinements: { value: string | number }[];
};

export const hasRefinement = (
  items: RefinementItem[],
  attribute: string,
  values: string[],
): boolean => {
  const hasAttribute = items.some((item) => item.attribute.includes(attribute));

  const hasValues = items.some((item) =>
    item.refinements.some((refinement) => values.includes(refinement.value as string)),
  );

  return hasAttribute && hasValues;
};

export const resourceIcons = {
  'Cheat Sheets': GiMagickTrick,
  'Past Papers': FaUserGraduate,
  'Practice Papers': FaPencilAlt,
  'Worksheets By Topic': SiLibreofficemath,
  Notes: GiNotebook,
  'Formulae Sheet': RiFormula,
  'Grade Boundaries': PiExamFill,
  'Practice Tests': FaPencilRuler,
  'Topic Tests': FaMedal,
  'Teaching Slides': GiTeacher,
  Textbooks: FaBook,
};
